import { Component, inject, input, OnInit, output } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { dsDtos, dsEnums } from '@vectronic/openApi-admin';
import { debounceTime, distinctUntilChanged, take } from 'rxjs';
import { GPS_FAMILY_TYPES } from '../../helpers/schedule-json.helper';
import { ScheduleTemplatesProviderService } from '../../services/schedule-templates-provider.service';

@Component({
  selector: 'rc-schedule-template-selector',
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './schedule-template-selector.component.html',
  styleUrls: ['./schedule-template-selector.component.scss'],
})
export class ScheduleTemplateSelectorComponent implements OnInit {
  private templatesProvider = inject(ScheduleTemplatesProviderService);

  scheduleType = input<dsEnums.ScheduleType>();
  templateSelected = output<dsDtos.ScheduleTemplateAdmin>();

  control = new FormControl<string | dsDtos.ScheduleTemplateAdmin>('', { nonNullable: true });
  templates = this.templatesProvider.templates;
  isLoading = this.templatesProvider.isLoading;

  constructor() {
    toObservable(this.scheduleType)
      .pipe(takeUntilDestroyed())
      .subscribe((type) => {
        if (type) {
          const mappedType: dsEnums.ScheduleType = GPS_FAMILY_TYPES.has(type) ? 'GPS' : type;
          this.templatesProvider.setScheduleType(mappedType);
        }
      });

    this.control.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntilDestroyed())
      .subscribe((value) => {
        const search = typeof value === 'string' ? value : (value?.templateName ?? '');
        this.templatesProvider.setTemplateName(search);
      });
  }
  ngOnInit(): void {
    this.templatesProvider.setTemplateName(undefined);
    this.templatesProvider.setUserIds([-1]);
  }

  displayFn(template: dsDtos.ScheduleTemplateAdmin | string): string {
    if (!template) return '';
    return typeof template === 'string' ? template : template.templateName;
  }

  onInputClick() {
    this.templatesProvider.refresh().pipe(take(1)).subscribe();
  }

  onSelected(template: dsDtos.ScheduleTemplateAdmin) {
    this.templateSelected.emit(template);
  }
}
